module.exports = __webpack_public_path__ + "static/media/3.58cdb029.webp";